import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { logsActions } from '@src/store/reducers/logsReducer';

export const createLogsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [logsActions.GET_LOGS]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Logger/GetLogs`, payload.data,{timeout: 600000 });
            const data = response.data;
            next({ type: logsActions.SET_LOGS, payload: { logs: data } });
            return data;
        },
        [logsActions.GET_SCHEMAS_FOR_LOG]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envId}/Schemes`);
            const data = response.data;
            next({ type: logsActions.SET_SCHEMAS_FOR_LOG, payload: { schemas: data } });
            return data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/logs.middleware.ts